import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import moment from 'moment';

//Components
import { Grid, Typography, Container, Paper, Divider, Icon } from "@mui/material";
import { NotificationManager } from 'Components/Notifications';
import DataView from 'Components/DataView';
import Filters from '../.components/filters';
import { getWarningTypes } from 'Utils/data';
import { Tooltip } from "@gpstrackit/react-controls";

//views
import RawMessageView from 'Modules/devices/.components/rawMessageView'

//Actions
import {
    maintenaceWarningRequest,
    maintenaceWarningSetList,
    rawMessageViewOpenModal,
    clearRedux
} from 'Redux/actions';

//Helpers
import { getDateFormatted } from 'Core/data/Helpers';

const ROWS_PER_PAGE = 20;

const MaintenanceWarnings = (props) => {
    const { messages } = useIntl();
    const { timezone } = props;

    const dispatch = useDispatch();

    //Redux states
    const { loading, Items, hasMore, error, errorCode, list } = useSelector(state => state.maintenanceWarningsVidfleetRedux);
    const open = useSelector(state => state.rawMessageViewRedux.openModal)

    const current_week = moment().startOf('week');
    const tempStartDate = new Date(current_week.toString());

    //Local states
    const [startDate, setStartDate] = useState(tempStartDate);
    const [endDate, setEndDate] = useState(new Date());
    const [beforeRangeDate, setBeforeRangeDate] = useState({
        start: tempStartDate,
        end: endDate
    })
    const [last, setLast] = useState({ id: '20', name: '20' });
    const [type, setType] = useState('last');
    const [esn, setEsn] = useState(props?.single ? props?.device?.esn || "" : "");
    const [warningValue, setWarningValue] = useState(null);

    const [columns, setColumns] = useState([
        {
            key: "camerasn",
            title: messages['vidfleet_camera_sm'],
            show: true,
            sort: false,
            locked: true,
            resize: true,
            export: true,
            width: 150,
            exportCell: "cameraSN",
            render: (item) => {
                return (
                    <NavLink to={`/app/devices/overview/${item?.cameraSN}`} style={{ color: 'black' }}>
                        <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{item?.cameraSN}</span>
                    </NavLink>
                )
            },
            code: 'vidfleet_camera_sm'
        },
        {
            key: 'maintenance-warning-view',
            show: true,
            locked: true,
            title: "",
            width: 40,
            icon: true,
            render: (item) => {
                return (
                    <Tooltip title={ messages["vidfleet_maintenance_warnings_view_details"]}>
                        <Icon style={{ cursor: "pointer" }} className="toolbar-list-icon fs-20" onClick={() => {
                            dispatch(rawMessageViewOpenModal(true, item?.detail || "", messages["vidfleet_maintenance_warnings_details"]))
                        }}>
                            remove_red_eye
                        </Icon>
                    </Tooltip>

                )
            }
        },
        {
            key: "warning",
            title: messages['vidfleet_warning'],
            show: true,
            sort: false,
            locked: false,
            resize: true,
            export: true,
            width: 250,
            exportValue: (item) => {
                let type = getWarningTypes(item.warning)
                return type ? type?.label : item.warning
            },
            render: (item) => {
                let type = getWarningTypes(item.warning)
                return <span>{type ? type?.label : item.warning}</span>
            },
            code: 'vidfleet_warning',
        },
        {
            key: "warningtime",
            title: messages['vidfleet_warning_time'],
            show: true,
            sort: false,
            locked: false,
            resize: true,
            export: true,
            exportCell: "createTime",
            exportFormat: "datetime",
            render: (item) => {
                return <span>{item?.createTime && getDateFormatted(item?.createTime, "date", "datetime", null, timezone)}</span>
            },
            code: 'vidfleet_warning_time',
        },
        {
            key: "warningaccount",
            title: messages['vidfleet_warning_account'],
            show: true,
            sort: false,
            locked: false,
            resize: true,
            export: true,
            exportCell: "adicionalInfo.company.name",
            render: (item) => {
                return (
                    <NavLink to={`/app/accounts/overview/${item?.adicionalInfo?.company?.id}`} style={{ color: 'black' }}>
                        <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{item?.adicionalInfo?.company?.name}</span>
                    </NavLink>
                )
            },
            code: 'vidfleet_warning_account',
        },
        {
            key: "warningpaireddevice",
            title: messages['vidfleet_warning_liked_unit'],
            show: true,
            sort: false,
            locked: false,
            resize: true,
            export: true,
            exportCell: "adicionalInfo.linkedUnit.esn",
            render: (item) => {
                return (
                    <NavLink to={`/app/devices/overview/${item?.adicionalInfo?.linkedUnit?.id}`} style={{ color: 'black' }}>
                        <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{item?.adicionalInfo?.linkedUnit?.esn}</span>
                    </NavLink>
                )
            },
            code: 'vidfleet_warning_liked_unit',
        },
        {
            key: "warningpaireddevicename",
            title: messages['vidfleet_warning_liked_unit_name'],
            show: true,
            sort: false,
            locked: false,
            resize: true,
            export: true,
            exportCell: "adicionalInfo.linkedUnit.label",
            render: (item) => {
                return (
                    <NavLink to={`/app/devices/overview/${item?.adicionalInfo?.linkedUnit?.id}`} style={{ color: 'black' }}>
                        <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{item?.adicionalInfo?.linkedUnit?.label}</span>
                    </NavLink>
                )
            },
            code: 'vidfleet_warning_liked_unit_name',
        },
        {
            key: "warningpaireddevicemodel",
            title: messages['vidfleet_warning_model'],
            show: true,
            sort: false,
            locked: false,
            resize: true,
            export: true,
            exportCell: "adicionalInfo.deviceModel.name",
            render: (item) => {
                return (
                    <span>{item?.adicionalInfo?.deviceModel?.name}</span>
                )
            },
            code: 'vidfleet_warning_model',
        }
    ])

    const getData = (refresh) => {
        if (refresh) dispatch(clearRedux("MAINTENANCE_WARNING", { hasMore: false, list: [], Items: [] }));

        let currentStarDate = new Date(startDate);
        let currentEndDate = new Date(endDate);

        let payload = {
            startDate: currentStarDate.setHours(0),
            endDate: currentEndDate.setHours(23, 59, 59),
            from: refresh ? 0 : Items.length || 0,
            limit: type === "last" ? last.id : ROWS_PER_PAGE,
            hasMore: refresh ? false : type === "last" ? false : hasMore,
            filterByDate: type === "range",
            esn: esn,
        }
        if(payload.startDate && payload.endDate){
            payload.startDate = new Date(payload.startDate)
            payload.endDate = new Date(payload.endDate)
        }
        dispatch(maintenaceWarningRequest(payload));
    }

    const handleWarningType = (type) => {
        if (type) {
            let listF = [];
            let currentFilter = type
            listF = Items.filter(x => x.warning === currentFilter?.id)
            dispatch(maintenaceWarningSetList([...listF]));
        } else dispatch(maintenaceWarningSetList([...Items]));
        setWarningValue(type);
    }

    useEffect(() => {
        let currentStarDate = new Date(startDate);
        let currentEndDate = new Date(endDate);
        let payload = {
            startDate: currentStarDate.setHours(0),
            endDate: currentEndDate.setHours(23, 59, 59),
            from: 0,
            limit: ROWS_PER_PAGE,
            hasMore: false,
            type: "last",
            esn: esn,
        }
        if(payload.startDate && payload.endDate){
            payload.startDate = new Date(payload.startDate)
            payload.endDate = new Date(payload.endDate)
        }
        if (list && list.length === 0) {
            dispatch(maintenaceWarningRequest(payload));
        }
        return () => {
            dispatch(clearRedux("MAINTENANCE_WARNING"));
        };
    }, [])

    useEffect(() => {
        if (error) {
            if (esn) {
                NotificationManager.error(
                    errorCode === 403 ? messages['vidfleet_the_esn_could_not_be_consulted'] : messages['vidfleet_the_esn_does_not_exist'],
                    messages['vidfleet_maintenance_warnings'],
                    3000,
                    null,
                    null,
                    'error'
                );
            } else {
                NotificationManager.error(
                    messages['vidfleet_error_maintenance_warnings'],
                    messages['vidfleet_maintenance_warnings'],
                    3000,
                    null,
                    null,
                    'error'
                );
            }
            dispatch(clearRedux("MAINTENANCE_WARNING", { error: null, errorCode: null }));
        }
    }, [error])

    useEffect(() => {
        if (Items) {
            let listF = [];
            listF = warningValue ? Items.filter(x => x.warning === warningValue?.id) : Items;
            dispatch(maintenaceWarningSetList([...listF]));
        }
    }, [Items])

    const handleLast = (type) => {
        dispatch(clearRedux("MAINTENANCE_WARNING", { hasMore: false }))
        setType(type);
    }

    return (
        <Container maxWidth={false} className={!props?.single ? "container-view" : "container-view-tab"}>
            <Paper elevation={0}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    style={{ padding: !props?.single ? "14px 18px" : 0, borderBottom: "1px solid #e8e8e8", height: '95v' }}
                >
                    {
                        !props?.single &&
                        <Grid item xs={6}>
                            <Typography variant="h5" gutterBottom component="div">
                                {messages['vidfleet_maintenance_warnings']}
                            </Typography>
                        </Grid>
                    }
                    {
                        !props?.single &&
                        <div style={{ width: '100%', marginBottom: 10, marginTop: 5 }}>
                            <Divider style={{ backgroundColor: '#999999' }} />
                        </div>
                    }
                    <DataView
                        name="pm-maintenance-warnings-v2"
                        exportName="maintenancewarnings"
                        externalLoading={loading}
                        externalData={list}
                        columns={columns}
                        topheight={props?.single ? 286 : 200}
                        noSplit
                        noSearch
                        noFilters
                        disableItemSelection
                        externalRefresh={() => getData(true)}
                        tableButtons={["export", 'orderColumn']}
                        extraFilters={() => {
                            return (
                                <>
                                    <Filters
                                        warningType
                                        startDate={startDate}
                                        endDate={endDate}
                                        setStartDate={setStartDate}
                                        setEndDate={setEndDate}
                                        setBeforeRangeDate={setBeforeRangeDate}
                                        beforeRangeDate={beforeRangeDate}
                                        last={last}
                                        setLast={setLast}
                                        onChangeFilters={() => getData(true)}
                                        type={type}
                                        setType={handleLast}
                                        esn={esn}
                                        setEsn={setEsn}
                                        setWarningValue={handleWarningType}
                                        warningValue={warningValue}
                                        disabled={loading}
                                        single={props?.single}
                                        module={props?.module}
                                        setModule={props?.setModule}
                                    />
                                </>
                            )
                        }}
                        onChangeColumns={(items) => setColumns(items)}
                        infiniteScroll
                        nextToken={type === "last" ? false : hasMore}
                        onChangePage={() => getData()}
                        toolbarFullWidth
                        dataGridExport
                        noPDF
                        flexEnd
                    />
                </Grid>
            </Paper>
            {open && <RawMessageView />}
        </Container>
    )
}
export default MaintenanceWarnings;